import { Chip } from '@patchbay/ui'

export interface BrandReference {
  slug?: string | null
  customer_facing_name?: string | null
  customerFacingName?: string | null
}

export function BrandChip({ brand }: { brand?: BrandReference | null }) {
  if (brand === undefined) return null
  const name = brand?.customerFacingName ?? brand?.customer_facing_name
  return (
    <Chip tone="outline" data-testid="brand-chip">
      {name?.trim() || 'Brand unresolved'}
    </Chip>
  )
}
